<div class="container">
  <div
    class="header"
    [style]="expanded ? 'margin-bottom:20px;' : 'margin-bottom:10px;'"
  >
    <p class="header-title">Asientos seleccionados: {{ selectedSeats.length }}</p>
    <span
    style="cursor:pointer;"
    class="material-symbols-outlined expand-btn" (click)="toggle()">{{
      !expanded ? 'arrow_circle_up' : 'arrow_circle_down'
    }}</span>
  </div>

  <div class="seats-list" *ngIf="expanded">
    <selected-seat-item
      [id]="'selected-seat-' +seat.seatId"
      [seat]="seat"
      *ngFor="let seat of selectedSeats"
    ></selected-seat-item>
  </div>

  <div class="footer">
    <button
      (click)="goToCheckout.emit()"
      class="checkout-btn"
      [disabled]="!selectedSeats.length"
    >
      Pasar a comprar (RD${{ subTotal.toLocaleString() }})
    </button>
  </div>
</div>
